import { Selector } from '@ngxs/store';

import { Feature } from '../../core/models/feature.model';
import { FeatureState, FeatureStateModel } from './feature.state';

export class FeatureGetterState {

  @Selector([FeatureState])
  static getLastActiveFeature(state: FeatureStateModel): Feature {
    return state.entities[state.lastActiveFeatureId];
  }
}
